import script from "./FormsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FormsHeader.vue?vue&type=script&setup=true&lang=js"

import "./FormsHeader.vue?vue&type=style&index=0&id=cbd88b52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbd88b52"]])

export default __exports__